import { DISTRIBUTION_BANDS } from './piEngagementModel.js';
import { JOURNEY_OPTIONS, journeyLabel, journeyText } from './piQuery.js';

export { JOURNEY_OPTIONS, journeyLabel, journeyText };

export const MIN_COMPANY_SEARCH = 2;

export const BAND_OPTIONS = DISTRIBUTION_BANDS.map((band) => ({ value: band.band, label: band.label }));

export const CONTRACT_OPTIONS = [
  { value: 'low', label: 'Usa menos da metade do contratado' },
  { value: 'over', label: 'Usa mais que o contratado' },
];

export const SIGNAL_DROP = 'drop';

export const INTERNAL_OPTIONS = [
  { value: 'only', label: 'Só demonstração' },
  { value: 'suggested', label: 'Sugestões' },
  { value: 'include', label: 'Todas' },
];

export const INTERNAL_HIDE_LABEL = 'Ocultar';

export const COMPANY_FILTER_DEFAULTS = { search: '', band: '', journey: '', signal: '', contract: '', internal: '' };

export const COMPANY_QUERY_KEYS = ['band', 'journey', 'signal', 'contract', 'internal'];

const textOf = (value) => (typeof value === 'string' ? value.trim() : (typeof value === 'number' ? String(value) : ''));

const allowed = (options, value) => options.some((option) => option.value === value);

export const cleanCompanyFilters = (value) => {
  const source = value && typeof value === 'object' ? value : {};
  const band = textOf(source.band);
  const journey = textOf(source.journey);
  const contract = textOf(source.contract);
  const internal = textOf(source.internal);
  return {
    search: textOf(source.search).slice(0, 60),
    band: allowed(BAND_OPTIONS, band) ? band : '',
    journey: allowed(JOURNEY_OPTIONS, journey) ? journey : '',
    signal: textOf(source.signal) === SIGNAL_DROP ? SIGNAL_DROP : '',
    contract: allowed(CONTRACT_OPTIONS, contract) ? contract : '',
    internal: allowed(INTERNAL_OPTIONS, internal) ? internal : '',
  };
};

export const internalParam = (value) => {
  const internal = cleanCompanyFilters({ internal: value }).internal;
  return internal ? { internal: internal } : {};
};

export const internalLabel = (value) => {
  const internal = cleanCompanyFilters({ internal: value }).internal;
  const found = INTERNAL_OPTIONS.filter((option) => option.value === internal)[0];
  return found ? found.label : INTERNAL_HIDE_LABEL;
};

export const internalFilterLine = (value) => {
  const internal = cleanCompanyFilters({ internal: value }).internal;
  return 'Demonstração: ' + (internal ? internalLabel(internal) : INTERNAL_HIDE_LABEL + ' (padrão: só o universo, sem as empresas de demonstração)');
};

export const companyFilterParams = (value) => {
  const clean = cleanCompanyFilters(value);
  const params = {};
  if (clean.search.length >= MIN_COMPANY_SEARCH) params.search = clean.search;
  COMPANY_QUERY_KEYS.forEach((key) => {
    if (clean[key]) params[key] = clean[key];
  });
  return params;
};

export const companyFiltersFromQuery = (query) => {
  const source = query && typeof query === 'object' ? query : {};
  const picked = {};
  COMPANY_QUERY_KEYS.forEach((key) => {
    picked[key] = Array.isArray(source[key]) ? source[key][0] : source[key];
  });
  return cleanCompanyFilters(picked);
};

export const companyFiltersToQuery = (value) => {
  const clean = cleanCompanyFilters(value);
  const query = {};
  COMPANY_QUERY_KEYS.forEach((key) => {
    if (clean[key]) query[key] = clean[key];
  });
  return query;
};

export const sameCompanyFilters = (a, b) => JSON.stringify(companyFiltersToQuery(a)) === JSON.stringify(companyFiltersToQuery(b));

export const withCompanyFilters = (query, value) => {
  const source = query && typeof query === 'object' ? query : {};
  const next = {};
  Object.keys(source).forEach((key) => {
    if (COMPANY_QUERY_KEYS.indexOf(key) === -1) next[key] = source[key];
  });
  return Object.assign(next, companyFiltersToQuery(value));
};

export const hasCompanyFilters = (value) => {
  const clean = cleanCompanyFilters(value);
  return !!(clean.search || clean.band || clean.journey || clean.signal || clean.contract || clean.internal);
};

export const toggleBand = (value, band) => {
  const clean = cleanCompanyFilters(value);
  return Object.assign({}, clean, { band: clean.band === band ? '' : textOf(band) });
};

export const quietSharedPartial = (rows, fields) => {
  const list = Array.isArray(rows) ? rows : [];
  const cells = [];
  list.forEach((row) => fields.forEach((field) => {
    const cell = row && row[field];
    if (cell && cell.metric && cell.metric.state === 'partial') cells.push(cell);
  }));
  if (!cells.length) return { rows: list, note: '' };
  const reason = cells[0].reason || '';
  if (!cells.every((cell) => (cell.reason || '') === reason)) return { rows: list, note: '' };
  const quiet = (cell) => (cell && cell.metric && cell.metric.state === 'partial' && (cell.reason || '') === reason
    ? Object.assign({}, cell, { badge: '', reason: '' })
    : cell);
  return {
    rows: list.map((row) => {
      const copy = Object.assign({}, row);
      fields.forEach((field) => {
        copy[field] = quiet(row[field]);
      });
      return copy;
    }),
    note: 'Números parciais' + (reason ? ': ' + reason : '') + '.',
  };
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piCompanyFilters.js